import ConversationSummaryHelper from 'app/utils/conversationSummaryHelper';
const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const REPLY_WINDOW_IN_MILLIS = 24 * HOUR - 1 * MINUTE;
/**
 * Returns a timestamp of when an agent can't reply to the conversation any
 * longer.
 */
export function getReplyWindowExpiresOnFromConversation(metaConversation) {
    var _a, _b, _c, _d;
    const helper = new ConversationSummaryHelper(metaConversation);
    const { conversation } = metaConversation;
    const transport_expires_at = (_a = conversation.attributes) === null || _a === void 0 ? void 0 : _a.transport_expires_at;
    if (transport_expires_at) {
        return new Date(transport_expires_at);
    }
    const eventsPresent = ((_c = (_b = conversation.events) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0;
    const authorsPresent = Object.keys((_d = conversation === null || conversation === void 0 ? void 0 : conversation.authors) !== null && _d !== void 0 ? _d : {}).length > 0;
    const channelIsFacebookMessenger = helper.isChannelFacebookMessenger();
    if (!eventsPresent || !authorsPresent || !channelIsFacebookMessenger) {
        return undefined;
    }
    const endUserId = helper.getRequestedBy();
    const lastMessageFromEndUser = [...metaConversation.messages]
        .reverse()
        .find((message) => message.author_id === endUserId &&
        message.type === 'conversation:message_added');
    if (!(lastMessageFromEndUser === null || lastMessageFromEndUser === void 0 ? void 0 : lastMessageFromEndUser.created_at)) {
        return undefined;
    }
    const lastMessageFromEndUserDate = new Date(lastMessageFromEndUser.created_at);
    return new Date(lastMessageFromEndUserDate.getTime() + REPLY_WINDOW_IN_MILLIS);
}
